import { formatForDto } from "client/DateAndTime/dateTimeUtils";
import { getHeaderName, getToken } from "client_legacy/ndaw/antiForgery";
import { Guid } from "client_legacy/ndaw/guid";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { AppType } from "../Apps/common";

export enum AnalyticsEventKind {
	Login = 0,
	App = 1
}

type AnalyticsLoginEvent = {
	eventKind: AnalyticsEventKind.Login;
};

export type AnalyticsAppEventData = {
	installedAppId: number;
	appType?: undefined;
} | {
	appType: AppType;
	installedAppId?: undefined;
};

type AnalyticsAppEvent = {
	eventKind: AnalyticsEventKind.App;
} & AnalyticsAppEventData;

export type AnalyticsEvent =
	| AnalyticsLoginEvent
	| AnalyticsAppEvent;

export type AnalyticsEventModel = {
	eventId: Guid;
	timestamp: string;
} & AnalyticsEvent;

type AnalyticsEventBatchModel = {
	currentTime: string;
	events: readonly AnalyticsEventModel[];
};

export async function registerAnalytics(
	events: readonly AnalyticsEventModel[]
): Promise<void> {
	const url: string = createUrlRelativeToEnvironment("UiApi/Analytics/Events");
	const headers: HeadersInit = {
		"Content-Type": "application/json; charset=utf-8",
		"Accept": "application/json"
	};

	const securityToken: string | undefined = getToken();
	if (securityToken) {
		const requestHeaderName: string = getHeaderName();

		headers[requestHeaderName] = securityToken;
	}

	const data: AnalyticsEventBatchModel = {
		currentTime: formatForDto(new Date()),
		events
	};

	try {
		await fetch(
			url,
			{
				method: "POST",
				headers,
				keepalive: true,
				body: JSON.stringify(data)
			}
		);
	} catch (e) {
		console.error(e);
	}
}